/**
 * @file JS - Helpers - Constants.js
 * @author Adam Lemire
 * @since 2019/08/01
 * @version 1.0
 * @summary Dernières modifications : 2021/05/26
 */

/**
 * @readonly
 * @enum { string }
 */
export const ClassificationType = {
  ATTRIBUTE: 'attribute',
  EQ_INTERVAL: 'eqInterval',
  GEOMETRIC: 'geometricProgression',
  JENKS: 'jenks',
  QUANTILE: 'quantile',
  STD_DEVIATION: 'stdDeviation'
};

/**
 * @readonly
 * @enum { string }
 */
export const ColorHexList = {
  BRIGHT: ['#e6194B', '#3cb44b', '#ffd700', '#4363d8', '#f58231', '#911eb4', '#42d4f4', '#f032e6', '#bfef45', '#a9a9a9'],
  LIGHT: ['#fabed4', '#aaffc3', '#fffac8', '#95a7e9', '#ffd8b1', '#dcbeff', '#9fe9f9', '#f8a0f3', '#dff7a1', '#e6e6e6'],
  DARK: ['#800000', '#2d8639', '#ccb100', '#000075', '#9A6324', '#691683', '#469990', '#be0eb5', '#9dd312', '#666666'],
  COLD_HOT: ['#247DEF', '#6BE2F5', '#E2FEDC', '#FC926E', '#EF4824']
}; // #ffe119

/**
 * @readonly
 * @enum { string }
 */
export const ColorGradient = {
  BLUE: 'blue',
  GREEN: 'green',
  RED: 'red'
};

const colorInterpolate = require('color-interpolate');
export const ColorPalettes = {
  rouge: colorInterpolate(['red', 'rgb(255, 200, 200)']),
  rougeInverse: colorInterpolate(['rgb(255, 200, 200)'], 'red'),
  vert: colorInterpolate(['green', 'rgb(200, 255, 200)']),
  vertInverse: colorInterpolate(['rgb(200, 255, 200)', 'green']),
  bleu: colorInterpolate(['blue', 'rgb(200, 200, 255)']),
  bleuInverse: colorInterpolate(['rgb(200, 200, 255)', 'blue']),
  blancBleu: colorInterpolate(['blue', 'white']),
  blancBleuInverse: colorInterpolate(['white', 'blue']),
  blancRouge: colorInterpolate(['red', 'white']),
  blancRougeInverse: colorInterpolate(['white', 'red']),
  blancVert: colorInterpolate(['green', 'white']),
  blancVertInverse: colorInterpolate(['white', 'green'])
};

export const EPSG = {
  default: 'EPSG:3857',
  3857: 'EPSG:3857'
};

export const FeatureType = {
  POINT: 'Point',
  LINE: 'Line',
  POLYGON: 'Polygon'
};

/**
 * @readonly
 * @enum { string }
 */
export const GradationType = {
  COLOR: 'color',
  SIZE: 'size',
  MULTIDIMENSIONS: 'multidimensions'
};

/**
 * @readonly
 * @enum { string }
 */
export const Luminosity = {
  LIGHT: 'light',
  BRIGHT: 'bright',
  DARK: 'dark'
};

/**
 * @readonly
 * @enum { string }
 */
export const MultiMapPageFormat = {
  HORIZONTAL: {
    selectIndex: 0,
    label: 'horizontal'
  },
  VERTICAL: {
    selectIndex: 1,
    label: 'vertical'
  },
  GRID: {
    selectIndex: 2,
    label: 'grid'
  },
  OVERLAY: {
    selectIndex: 3,
    label: 'overlay'
  }
};

export const StyleTypes = {
  SINGLE: 'single-symbol',
  CATEGORIZED: 'categories',
  GRADUATED: 'graduated'
};

export const TypeAttribut = {
  FLOAT: 'float',
  INTEGER: 'integer',
  STRING: 'string'
};

/* exemple style point icone
var iconStyle = new Style({
  image: new Icon(// @type {module:ol/style/Icon~Options} ({
    anchor: [0.5, 46],
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    src: 'data/icon.png'
  }))
});
*/
